import { render, staticRenderFns } from "./viewPayableStatement.vue?vue&type=template&id=04279380&scoped=true&"
import script from "./viewPayableStatement.vue?vue&type=script&lang=js&"
export * from "./viewPayableStatement.vue?vue&type=script&lang=js&"
import style0 from "./viewPayableStatement.vue?vue&type=style&index=0&id=04279380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04279380",
  null
  
)

export default component.exports